import { render, staticRenderFns } from "./WarmUp6-3.vue?vue&type=template&id=3afd8250&"
import script from "./WarmUp6-3.vue?vue&type=script&lang=js&"
export * from "./WarmUp6-3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports